import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { ReportesAnioData, ReportesTodosData } from "@cold-crew/shared";

// ─── Query Keys ───────────────────────────────────────────────────────────────

export const reportesKeys = {
  all:   () => ["reportes"] as const,
  anio:  (year: number) => [...reportesKeys.all(), "anio", year] as const,
  todos: () => [...reportesKeys.all(), "todos"] as const,
};

// ─── useReportesAnio ──────────────────────────────────────────────────────────

export function useReportesAnio(year: number) {
  return useQuery({
    queryKey: reportesKeys.anio(year),
    queryFn:  () => api.get<ReportesAnioData>("/reportes/anio", { year }),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}

// ─── useReportesTodos ─────────────────────────────────────────────────────────

export function useReportesTodos() {
  return useQuery({
    queryKey: reportesKeys.todos(),
    queryFn:  () => api.get<ReportesTodosData>("/reportes/todos"),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
